// @ts-nocheck

import { request } from '../../../../context';
import type { ApiOptions } from '../../../../context';
import type {
    GetDataTicketRelatedCallByIdParam,
    BaseResponseListDataCall,
} from '../../../../types';

/**
 * 查询工单的关联通对话
 *
 * @export
 * @tags 通对话管理
 * @link [GET] /data/ticket/related-call/{id}
 * @param id
 */
export function getDataTicketRelatedCallById(
    options: ApiOptions<GetDataTicketRelatedCallByIdParam, never> & {
        segments: GetDataTicketRelatedCallByIdParam;
    }
): Promise<BaseResponseListDataCall> {
    return request<never, GetDataTicketRelatedCallByIdParam, never>(
        '/data/ticket/related-call/{id}',
        { ...options, method: 'get', __$requestCalleeName: 'getDataTicketRelatedCallById' }
    );
}

export const meta = [
    { tags: ['通对话管理'], path: '/data/ticket/related-call/{id}', method: 'get' },
];
